import {
	type AnyQuestion,
	type Country,
	getQuestionnaireInitialValues,
	Questionnaire,
	type QuestionnaireFormValues,
} from "@sveabank/cc-common";

type Props = {
	questions: Array<AnyQuestion>;
	productId: string;
	allCountries: Country[];
	onSubmit: (values: QuestionnaireFormValues) => Promise<void>;
};

const AmlQuestions = ({ onSubmit, questions, allCountries }: Props) => {
	const initialValues = getQuestionnaireInitialValues(questions);
	return (
		<Questionnaire
			onSubmit={onSubmit}
			questions={questions}
			initialValues={initialValues}
			allCountries={allCountries}
		/>
	);
};
export default AmlQuestions;
